// extracted by mini-css-extract-plugin
export default {"button":"button-form_button__4mpE0"};